import React from 'react';
import { Table, Label } from 'semantic-ui-react';
import { problemTypeLabel } from './constants';
import { formatDateToMmDdYyyy } from '../../utils/formatDate';

// Shared row list for a team's asset problems — used by both the standalone detail route
// and the inline same-page team panel on the main dashboard. Rows open the asset's problem
// detail page in a new tab (rather than navigating away) when an asset id is available
// (backend sends it as `asset`, matching the field name used elsewhere, e.g.
// MaintenanceTableConfig), so the dashboard's current filters/accordion state is preserved.
export const AssetProblemsTable = ({ problems }) => {
    return (
        <div className="apr-breakdown-table">
            <Table basic="very" compact unstackable className="apr-table">
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell>Asset</Table.HeaderCell>
                        <Table.HeaderCell>Asset Type</Table.HeaderCell>
                        <Table.HeaderCell>Make/Model</Table.HeaderCell>
                        <Table.HeaderCell>Year</Table.HeaderCell>
                        <Table.HeaderCell>VIN</Table.HeaderCell>
                        <Table.HeaderCell>Problem Type</Table.HeaderCell>
                        <Table.HeaderCell>Created</Table.HeaderCell>
                        <Table.HeaderCell>Resolved</Table.HeaderCell>
                        <Table.HeaderCell>Actual Fix Date</Table.HeaderCell>
                        <Table.HeaderCell>Days Open</Table.HeaderCell>
                        <Table.HeaderCell>Red Tag</Table.HeaderCell>
                    </Table.Row>
                </Table.Header>
                <Table.Body>
                    {problems.map((problem) => {
                        const assetId = problem.asset ?? problem.assetId;
                        const to = assetId ? `/assets/${assetId}/problems/${problem.id}` : null;
                        return (
                            <Table.Row
                                key={problem.id}
                                className={to ? 'apr-row-clickable' : undefined}
                                onClick={to ? () => window.open(to, '_blank', 'noopener,noreferrer') : undefined}
                            >
                                <Table.Cell>{problem.assetName || problem.asset || '—'}</Table.Cell>
                                <Table.Cell>{problem.assetType || '—'}</Table.Cell>
                                <Table.Cell>{problem.make || '—'} / {problem.model || '—'}</Table.Cell>
                                <Table.Cell>{problem.year || '—'}</Table.Cell>
                                <Table.Cell>{problem.vin || '—'}</Table.Cell>
                                <Table.Cell>{problemTypeLabel(problem.problemType || problem.summary)}</Table.Cell>
                                <Table.Cell>{problem.createdTime ? formatDateToMmDdYyyy(problem.createdTime) : '—'}</Table.Cell>
                                <Table.Cell>
                                    {problem.resolved
                                        ? (problem.resolvedDate ? formatDateToMmDdYyyy(problem.resolvedDate) : 'Yes')
                                        : 'No'}
                                </Table.Cell>
                                <Table.Cell>{problem.actualFixDate ? formatDateToMmDdYyyy(problem.actualFixDate) : '—'}</Table.Cell>
                                <Table.Cell>{problem.daysOpen ?? '—'}</Table.Cell>
                                <Table.Cell>
                                    {problem.redTag && <Label color="red" size="small">Red Tag</Label>}
                                </Table.Cell>
                            </Table.Row>
                        );
                    })}
                </Table.Body>
            </Table>
        </div>
    );
};
